import {useState, useEffect} from 'react';
import {usePortalClient} from '../context/PortalClientContext';
import {AccessService} from '../utils/AccessService';
import {LocalStorage} from '../utils/LocalStorage';

// Módulos del NAV del portal. Con multi-cliente son del CLIENTE ACTIVO (viajan dentro de
// clients[] del login / portal/me/clients/, así el switch es instantáneo). Fallback legacy:
// el fetch per-usuario de siempre (GetUserModules) para sesiones/backends previos al deploy.
export const usePortalModules = () => {
    const {isPreview, activeModules} = usePortalClient();
    const [legacyModules, setLegacyModules] = useState(null);
    const needsLegacyFetch = !isPreview && activeModules === null;

    useEffect(() => {
        if (!needsLegacyFetch) return;
        const userId = LocalStorage.fetchUserId();
        if (!userId) return;
        AccessService.GetUserModules(userId, (data) => {
            setLegacyModules(data.modules || []);
        }, () => {
            setLegacyModules([]);
        });
    }, [needsLegacyFetch]);

    if (activeModules !== null) {
        return activeModules;
    }
    return needsLegacyFetch ? legacyModules : activeModules;
};
